import { useEffect, useState } from "react";
import { AppLayout } from "../../components/layout/Header";
import CalendarWidget from "../../components/widgets/CalendarWidget";
import EventDetailsForm, { EMPTY_EVENT } from "../../components/desk/EventDetailsForm";
import AppointmentSummary from "../../components/desk/AppointmentSummary";
import { createEvent, listEvents } from "../../js/api/calendarApi";
import { loadEventDraft, saveEventDraft } from "../../js/api/eventDraft";
import { useAgentScope } from "../../js/hooks/useAgentScope";
import { useDesk } from "../../js/hooks/useDesk";

export default function AgentCalendar() {
  const { listAgentId, writeAgentId, excludeAgentId } = useAgentScope();
  const desk = useDesk();
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [form, setForm] = useState(() => ({
    ...EMPTY_EVENT,
    ...(loadEventDraft(writeAgentId) || {}),
    date: new Date().toISOString().slice(0, 10),
  }));

  useEffect(() => {
    listEvents(listAgentId, excludeAgentId, { role: desk.variant === "broker" ? "broker" : "agent" }).then(setEvents);
  }, [listAgentId, excludeAgentId]);

  function handleChange(next) {
    setForm(next);
    saveEventDraft(writeAgentId, next);
  }

  async function handleSubmit(next) {
    const created = await createEvent({
      ...next,
      agentId: writeAgentId,
    });
    setEvents((current) => [...current, created]);
    const reset = { ...EMPTY_EVENT, date: next.date, time: "10:00" };
    setForm(reset);
    saveEventDraft(writeAgentId, reset);
  }

  return (
    <AppLayout variant={desk.variant === "broker" ? "broker" : "agent"}>
      <h1>Calendar</h1>
      <div className="two-col" data-tour="calendar-page">
        <div className="desk-calendar-stack">
          <CalendarWidget
            events={events}
            selectedDate={selectedDate}
            onSelectDate={setSelectedDate}
            compact
            indicatorsOnly
          />
          <AppointmentSummary draft={form} events={events} />
        </div>
        <EventDetailsForm value={form} onChange={handleChange} onSubmit={handleSubmit} />
      </div>
    </AppLayout>
  );
}
